import * as types from '@/store/types'
export default {
    loadLeadLists: (context, payload) => {
        let unsortedMessagesListId = payload.find(messageList => messageList.deleted === 2)
        context.unsortedMessagesListId = unsortedMessagesListId.id
        context.messageLists = payload
        context.messageListsLoaded = true
    },
    addLead(context, payload) {
        context.leads.push(payload)
    },
    loadLeads(context, payload) {
        context.leads = payload
    },
    setLead: (context, payload) => {
        const index = context.leads.findIndex(item => item.id === payload.id)
        context.leads[index] = payload
    },
    changeBotIdModelDefault: (context, botId) => {
        context.modelDefault.bot_id = botId
    }
}
